import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableActionButton } from './table-action-group.interface';

@Component({
  selector: 'red-table-action-group',
  templateUrl: './table-action-group.component.html',
  styleUrls: ['./table-action-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableActionGroupComponent {
  @Input() actions: ITableActionButton[] = [];
  @Input() item: any;
  @Input() isLoading?: boolean;
  @Input() maxInlineActions?: number = 3;
  @Output() actionClick = new EventEmitter<ITableActionButton>();
}
